<template>
    <div class="carousel">
      <div class="carousel-inner" >
        <slot></slot>
      </div>
      <div class="carousel-nav">
        <button @click="prev">
           <img src="../../assets/prev.png" alt="prev" height="auto" width="auto" />
        </button>
        <button @click="next">
            <img src="../../assets/next.png" alt="next" height="auto" width="auto" />
        </button>
      </div>
      <div class="carrusel-group-btn">
        <button v-for="(pages, index) in pages" :key="index" @click.prevent="indexPage(index)" class="carrusel-btn"
            :class="{ active: index === currentIndex }">
        </button>
    </div>
    </div>
  </template>
   
  <script setup>
  import { ref, onMounted } from 'vue'
   
  const currentIndex = ref(0)
  const pages = ref([])
   
  onMounted(() => {
    pages.value = Array.from(document.querySelectorAll('.carousel-inner > div'))
    pages.value.forEach((page, index) => {
    page.style.width = '100%'
    page.style.display = index === 0 ? 'flex' : 'none'
    
    })
  })
   
  function next() {
    currentIndex.value = (currentIndex.value + 1) % pages.value.length
    updatePages()
  }
   
  function prev() {
    currentIndex.value = (currentIndex.value - 1 + pages.value.length) % pages.value.length
    updatePages()
  }
  const indexPage = (index) => {
    currentIndex.value = index
    updatePages()
}
   
  function updatePages() {
  pages.value.forEach((page, index) => {
  page.style.display = index === currentIndex.value ? 'block' : 'none'
  
})
  }
  </script>
   
  <style>
  .carrusel-group-btn{
    display: flex;
    justify-content: center;
    transform: translateY(-30px);
    align-items: center;
    gap: 4px;
  }
  .carrusel-btn.active {
    background-color: white;
    padding: 12px;
    height: 12px;
}
.carrusel-btn {
    border-radius: 50%;
    border: none;
    background-color: #e7e7ed;
    padding: 8px;
    height: 8px;
    cursor: pointer
}


  .carousel {
    position: relative;
    overflow: hidden;
  }
   
  .carousel-inner {
    display: flex;
    transition: transform 0.3s ease-in-out;
  }
   
  .carousel-nav {
   width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
     display: flex;
    justify-content:space-between;
    
  }
   
  .carousel-nav button {
    cursor: pointer;
    background: none;
    border: none;
    font-size: 24px;
    padding: 10px;
  }
  </style>